/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import parameters, {
	type RovoOpsComponentQuery,
} from '@jira/servicedesk__rovo-ops/src/__generated__/RovoOpsComponentQuery.graphql.ts';
import { fg } from '@atlassian/jira-feature-gating';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { RovoOpsViewEntrypointProps } from './RovoOpsView.entrypoint.types.tsx';

type RovoOpsSettingsEntryPointComponent = EntryPointComponent<
	{
		rovoOpsComponentQuery: RovoOpsComponentQuery;
	},
	Record<string, never>,
	RovoOpsViewEntrypointProps,
	Record<string, never>
>;

export const rovoOpsSettingsEntryPoint: EntryPoint<
	RovoOpsSettingsEntryPointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<RovoOpsSettingsEntryPointComponent>(
		/* webpackChunkName: "async-project-settings-rovo-ops", jiraSpaEntry: "async-project-settings-rovo-ops" */ './ProjectSettingsServiceDeskRovoOpsRovoOpsView.tsx',
	),
	getPreloadProps: ({ tenantContext }: EntryPointRouteParams) => ({
		queries: {
			rovoOpsComponentQuery: {
				parameters,
				variables: {
					cloudIdString: tenantContext.cloudId,
					cloudIdID: tenantContext.cloudId,
					externalReference: 'ops_guide_agent',
					newRelicDimensionIds: ['ari:cloud:platform::product/newrelic/newrelic'],
					dynatraceDimensionIds: ['ari:cloud:platform::product/dynatrace/dynatrace'],
					honeycombDimensionIds: ['ari:cloud:platform::product/honeycomb/honeycomb'],
					coralogixDimensionIds: fg('rovo_ops_settings_page_coralogix')
						? ['ari:cloud:platform::product/coralogix/coralogix']
						: [],
					lansweeperDimensionIds: fg('rovo_ops_settings_page_lansweeper')
						? ['ari:cloud:platform::product/lansweeper/lansweeper']
						: [],
				},
				options: {
					fetchPolicy: 'store-or-network' as const,
				},
			},
		},
		entryPoints: {},
		extraProps: {},
	}),
});
